import { MONTH } from "@/constants/day";

const MonthField = ({ value }) => {
  const month = MONTH.find((m) => m.value === value);
  return month ? <div>{month.label}</div> : <div>{value}</div>;
};

export default MonthField;
